module.exports = __webpack_public_path__ + "img/weddingRingsMorningGlow-emotion-01@2x.59963aa.webp";